import { render } from "./actionComponent.vue?vue&type=template&id=3009ae2d"
import script from "./actionComponent.vue?vue&type=script&lang=js"
export * from "./actionComponent.vue?vue&type=script&lang=js"

import "./actionComponent.vue?vue&type=style&index=0&id=3009ae2d&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__